import React from "react";

const WordAssociation = () => {
    return <div>Word Association</div>;
};

export default WordAssociation;